<template>
    <div class="squad-box">
        <div class="loading-box">
            <div class="loading-list py-16px">
                <div class="loading-item pb-16px">
                    <div class="pt-12px py-1850px">
                        <div class="pill animation pill-squad-title"></div>
                    </div>
                    <div class="py-1456px display-flex-align-center gap-12px" v-for="(i, index) in 2" :key="index">
                        <div class="pill animation pill-4 pill-6 px-0750px"></div>
                        <div class="circle animation circle-squad"></div>
                        <div>
                            <div class="display-flex-align-center mb-4px">
                                <div class="circle animation mr-05rem"></div>
                                <div class="pill animation pill-4 w-59px"></div>
                            </div>
                            <div class="pill animation pill-4 w-130px"></div>
                        </div>
                    </div>
                </div>

                <div class="loading-item pb-16px">
                    <div class="pt-12px py-1850px">
                        <div class="pill animation pill-squad-title"></div>
                    </div>
                    <div class="py-1456px display-flex-align-center gap-12px" v-for="(i, index) in 2" :key="index">
                        <div class="pill animation pill-4 pill-6 px-0750px"></div>
                        <div class="circle animation circle-squad"></div>
                        <div>
                            <div class="display-flex-align-center mb-4px">
                                <div class="circle mr-05rem"></div>
                                <div class="pill animation pill-4 w-59px"></div>
                            </div>
                            <div class="pill animation pill-4 w-130px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading2'
    }
</script>


<style scoped src="../../assets/css/loading/index.css"></style>